// @ts-nocheck
import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import ConfirmModal from "components/shared-components/ConfirmModal";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { DELAY_FILTER_TIME } from "constants/RemoteDataTableContanst";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { useTranslation } from "react-i18next";
import MetaTags from "react-meta-tags";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  Row,
  Spinner,
  Label,
  Input,
} from "reactstrap";
import { Switch } from "antd";

import { GroupTransportMultiFilter } from "components/Common/GroupTransportSelect";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import HubMultiSelectFilter, {
  joinMultiSelectIds,
  parseMultiSelectIds,
  useHubMultiSelectOptions,
} from "components/shared-components/HubMultiSelectFilter";
import { ROLE_APP, actionAccess } from "constants/actionAccess";
import {
  ORDER_TYPE,
  OPTION_ORDER_GROUP,
  SHIPPING_TYPE,
  STATUS,
  STATUS_FILTER_KEY,
  TIME_SLOT_TYPE,
} from "constants/order";
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
} from "constants/RemoteDataTableContanst";
import {
  CheckActionAccess,
  CheckActionAccessList,
  splitText,
  useQueryRouter,
} from "helpers/utils";
import {
  useCancelOrder,
  useCancelOrderReasonList,
  useChangeOrderStatusMultiple,
  useCreateOrderGetGoods,
  useExportOrdersActive,
  useForwardOrderMultiple,
  useListOrdersActive,
  useListFunctionRole,
  useListShippingUnitAll,
  useOrderStatus,
  useRetryOrder,
  useTimeSlots,
  useTypeOrder,
  useUpdateOrderCost,
} from "hooks";
import {
  formatOrderCostMoney,
  fromOrderCostThousandUnit,
  parseOrderCostMoney,
  toOrderCostThousandUnit,
} from "helpers/orderCostHelper";
import jwt_decode from "jwt-decode";
import moment from "moment";
import UpdateRefCodeModal from "pages/ ScanTheRow/UpdateRefCode/UpdateRefCodeModal";
import CoordinateCollectorOrder from "pages/BloodCollectionOrder/DetailPage/OrderDetailFunction/CoordinateCollectorOrder";
import CreateOrderGetGoodsModal from "pages/ManageOrders/CreateOrderGetGoodsModal/CreateOrderGetGoodsModal";
import { findOrderType } from "pages/ManageOrders/GroupButtonOrderType";
import OrderCodeCopy from "pages/ManageOrders/OrderCodeCopy";
import RefCode from "pages/Orders/RefCode";
import {
  checkErrorForHandleOrdersCoordinate,
  checkItemAcceptForUpdateExitsRefCode,
  copyInformationOrderToClipboard,
  orderStatusMode,
} from "pages/Orders/utils";
import { customFilter, textFilter } from "react-bootstrap-table2-filter";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import ChangeOrderStatusForm, {
  checkIsAnyNotAllowedGroupToTransfer,
} from "../Orders/OrderDetail/ChangeOrderStatusForm/ChangeOrderStatusForm";
import OrderCoordinationForm from "../Orders/OrderDetail/OrderCoordination/OrderCoordinationForm/OrderCoordinationForm";

const initParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    columnFilter: {
      transport_group_code: "runner",
      "filter[action_date][lte]": moment().format("YYYY-MM-DD"),
    },
    keywords: "",
    expand:
      "from_hub_name,to_hub_name,transport_name,mainNote,is_receive_bus_cost_value_mismatch",
    run: false,
  };
};

const initRunnerByRuleParams = {
  action_date: "",
  time_slot: 0,
  province_code: "",
  district_code: "",
  ward_code: "",
};
const ManageOrdersPageActive = () => {
  let queryRouter = useQueryRouter();
  const { t } = useTranslation(["myOrders"]);
  const { addToast } = useToasts();
  const navigate = useNavigate();
  const updateRefCodeModalRef = useRef(null);
  const allFilterOption = {
    value: "All",
    label: t("filters.all"),
  };
  /* ================================== START INIT STATE ==================================== */
  const [isLogAdmin, setIsLogAdmin] = useState(false);
  const [isHubAdmin, setIsHubAdmin] = useState(true);
  const [orderParams, setOrderParams] = useState(initParams);
  const [selectedHubIds, setSelectedHubIds] = useState([]);
  const isHubFilterInitializedRef = useRef(false);
  const [columnsTable, setColumnsTable] = useState([]);
  const [actionType, setActionType] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [selectedRow, setSelectedRow] = useState({ order_code: null });
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [editingCostOrderId, setEditingCostOrderId] = useState(null);
  const [editingCostValue, setEditingCostValue] = useState("");

  const { mutate: mutateUpdateOrderCost } = useUpdateOrderCost(
    () => {
      setEditingCostOrderId(null);
      listOrders();
    },
    () => {
      setEditingCostOrderId(null);
    }
  );

  const handleUpdateOrderCost = (orderId, thousandDigits) => {
    const numericCost = fromOrderCostThousandUnit(thousandDigits);
    mutateUpdateOrderCost({
      orderId,
      cost_value: numericCost,
    });
  };

  // Hàng được click action để thực hiện hành động
  const [selectedRowAction, setSelectedRowAction] = useState(null);

  const [hubId, setHubId] = useState(null);
  const [isAddressLevel2, setIsAddressLevel2] = useState(undefined); // Add this line
  const [selectedOrderCode, setSelectedOrderCode] = useState([]);
  const [runnerByRuleParams, setRunnerByRuleParams] = useState(
    initRunnerByRuleParams
  );

  const [defaultDataOrderCoordination, setDefaultDataOrderCoordination] =
    useState({
      timeslot_id: null,
      runner_id: null,
      full_address: null,
      ward_code: null,
      district_code: null,
      province_code: null,
      contact_name: null,
      contact_phone: null,
      note: null,
    });

  const [is_level_2, setIsLevel2] = useState(true);
  const handleChangeIsLevel2 = value => {
    setIsLevel2(value);
  };

  const [openForwardOrderPopup, setOpenForwardOrderPopup] = useState(false);
  const [statusListAllOptions, setStatusListAllOptions] = useState([]);
  const [openChangeOrderStatusPopup, setOpenChangeOrderStatusPopup] =
    useState(false);
  const [dataCancelOrder, setDataCancelOrder] = useState({
    orderId: null,
  });
  const [cancelOrderModal, setCancelOrderModal] = useState(false);

  const [
    dataDefaultCreateOrderGetGoodsPopup,
    setDataDefaultCreateOrderGetGoodsPopup,
  ] = useState({
    isCreateAfterOpen: false,
    order: null,
    bus_id: null,
    hub: null,
  });
  const [openCreateOrderGetGoodsPopup, setOpenCreateOrderGetGoodsPopup] =
    useState(false);
  const toggleOpenCreateOrderGetGoodsPopup = () => {
    setOpenCreateOrderGetGoodsPopup(!openCreateOrderGetGoodsPopup);
  };

  const [isFilterOrderBusLate, setIsFilterOrderBusLate] = useState(false);

  const [timeSlotsSelect, setTimeSlotsSelect] = useState(null);
  const [addressLevelFilter, setAddressLevelFilter] = useState({
    value: "all",
    label: "Tất cả",
  });

  const [isOpenAddrFilter, setIsOpenAddrFilter] = useState(false);
  const addressLevelFilterOptions = [
    { value: "all", label: "Tất cả" },
    { value: "2", label: "2 cấp" },
    { value: "3", label: "3 cấp" },
  ];
  const handleAddressLevelFilterChange = selectedOption => {
    setAddressLevelFilter(selectedOption);

    const columnFilter = { ...orderParams.columnFilter };

    if (selectedOption.value === "2") {
      columnFilter["filter[is_new_address]"] = "N";
    } else if (selectedOption.value === "3") {
      columnFilter["filter[is_new_address]"] = "O";
    } else {
      // Remove filter when selecting "Tất cả"
      delete columnFilter["filter[is_new_address]"];
    }

    setOrderParams(prev => ({
      ...prev,
      page: 1,
      columnFilter,
    }));
  };

  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  useListFunctionRole({ params: {}, isEnabled: true });

  const { hubSelectOptions, isLoading: isHubOptionsLoading } =
    useHubMultiSelectOptions({
      queryKey: "manage-orders-active-hubs",
    });

  const applyHubFilterToOrderParams = useCallback(
    nextSelectedHubIds => {
      if (!hubSelectOptions.length) {
        return;
      }

      const hubFilterIds = joinMultiSelectIds({
        selectedIds: nextSelectedHubIds,
        options: hubSelectOptions,
      });

      if (!hubFilterIds) {
        return;
      }

      const columnFilterKeep = {
        ...(orderParams.columnFilterKeep || {}),
        hub_id: hubFilterIds,
      };
      const hubIdsForTimeSlots = parseMultiSelectIds(hubFilterIds);

      setTimeSlotsSelect(null);
      setTimeSlotsFilterParams(prev => ({
        ...prev,
        params: {
          ...prev.params,
          "filter[hub_id][in]": hubIdsForTimeSlots,
        },
        run: true,
      }));

      setOrderParams(prev => {
        const columnFilter = { ...prev.columnFilter };
        delete columnFilter["filter[timeslot_id]"];

        return {
          ...prev,
          page: 1,
          run: true,
          columnFilterKeep,
          columnFilter: {
            ...columnFilter,
            ...columnFilterKeep,
            "filter[transport_id]": undefined,
          },
        };
      });
    },
    [hubSelectOptions, orderParams.columnFilterKeep]
  );

  useEffect(() => {
    if (
      isHubOptionsLoading ||
      !hubSelectOptions.length ||
      isHubFilterInitializedRef.current
    ) {
      return;
    }

    isHubFilterInitializedRef.current = true;

    const defaultSelectedHubIds = undefined;

    setSelectedHubIds([]);
    applyHubFilterToOrderParams(defaultSelectedHubIds);
  }, [applyHubFilterToOrderParams, hubSelectOptions, isHubOptionsLoading]);

  const handleHubMultiSelectChange = nextHubIds => {
    setSelectedHubIds(Array.isArray(nextHubIds) ? nextHubIds : []);
    applyHubFilterToOrderParams(nextHubIds);
  };

  const isAllowCreate = CheckActionAccess(actionAccess.GLOG_FUNCTION_ORDER_ADD);
  const isAllowExport = CheckActionAccess(
    actionAccess.GLOG_FUNCTION_ORDER_EXPORT
  );

  // TIME SLOTS
  const [timeSlotsParams, setTimeSlotsParams] = useState({
    params: {
      "filter[type][in]": [TIME_SLOT_TYPE.COORDINATE, TIME_SLOT_TYPE.RUNNER],
      "filter[hub_id]": undefined,
    },
    run: false,
    enabled: false,
    key: "time-slot-orders",
  });
  const [timeSlotsFilterParams, setTimeSlotsFilterParams] = useState({
    params: {
      // "filter[type][in]": [TIME_SLOT_TYPE.DVVC],
      "filter[type][in]": [TIME_SLOT_TYPE.BUS],
    },
    run: false,
    enabled: false,
    key: "time-slot-filter",
  });

  const { data: timeSlots, refetch: refetchTimeSlots } =
    useTimeSlots(timeSlotsParams);
  const { data: timeSlotsFilter, refetch: refetchTimeSlotsFilter } =
    useTimeSlots(timeSlotsFilterParams);

  useEffect(() => {
    if (timeSlotsParams && timeSlotsParams?.run) {
      refetchTimeSlots();
    }
  }, [timeSlotsParams]);

  useEffect(() => {
    if (timeSlotsFilterParams && timeSlotsFilterParams?.run) {
      refetchTimeSlotsFilter();
    }
  }, [timeSlotsFilterParams]);

  const onSuccessCreateOrderGetGoods = _data => {
    switch (_data.type) {
      case ORDER_TYPE.RECEIVE.value:
        window.open(
          `/manage-orders/${_data.id}`,
          "_blank",
          "noopener,noreferrer"
        );
        break;
      default:
        break;
    }
  };

  const {
    isLoading: isLoadingCreateOrderGetGoods,
    mutate: mutateCreateOrderGetGoods,
    data: dataCreateOrderGetGoods,
    reset: resetCreateOrderGetGoods,
  } = useCreateOrderGetGoods(onSuccessCreateOrderGetGoods);

  const onChangeGroupTransportMulti = selectedCodes => {
    if (selectedCodes?.length) {
      setOrderParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          "filter[transport_id]": undefined,
          transport_group_code: selectedCodes.join(","),
          "filter[shipping_type][in]": undefined,
        },
      }));
    } else {
      setOrderParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          "filter[transport_id]": undefined,
          transport_group_code: undefined,
          // "filter[shipping_type][in]": [
          //   SHIPPING_TYPE.DVVC,
          //   SHIPPING_TYPE.NHAXE,
          // ],
        },
      }));
    }
  };

  // SHIPPING UNIT
  const onFetchShippingTypeAllSuccess = response => {
    const shippingTypesResponse = [allFilterOption];

    if (response) {
      for (const key in response) {
        const objShippingType = {
          value: key,
          label: response[key],
        };
        shippingTypesResponse.push(objShippingType);
      }
    }
  };

  const { refetch: listShippingTypeAll } = useListShippingUnitAll(
    onFetchShippingTypeAllSuccess
  );

  // FORWARD ORDER

  const onSuccessForwardOrder = () => {
    listOrders();
  };

  const { mutate: onForwardOrder } = useForwardOrderMultiple(
    onSuccessForwardOrder
  );

  // CHANGE ORDER STATUS

  const onSuccessChangeOrderStatus = () => {
    listOrders();
  };

  const { mutate: changeOrderStatus } = useChangeOrderStatusMultiple(
    onSuccessChangeOrderStatus
  );

  // ORDER STATUS

  const onFetchStatusListSuccess = response => {
    setStatusListAllOptions([
      allFilterOption,
      ...response.filter(n => !["4", "5", "7"].includes(n.value)),
    ]);
  };

  const {
    refetch: onFetchStatusList,
    data: orderStatusList,
    isFetching: isLoadingOrderStatus,
  } = useOrderStatus(onFetchStatusListSuccess);

  // CANCEL ORDER

  const handleCancelOrderSuccess = () => {
    listOrders();
  };

  const { mutate: cancelOrder } = useCancelOrder(handleCancelOrderSuccess);

  // REASONS

  const { refetch: onFetchReasons, data: reasonListData } =
    useCancelOrderReasonList(1);

  // ORDER LIST

  const {
    data: orderList,
    isFetching: isLoadingListOrder,
    refetch: listOrders,
  } = useListOrdersActive({
    params: orderParams,
  });

  const { data: listOrderType } = useTypeOrder();

  const selectedTransportGroupCodes = useMemo(() => {
    const raw = orderParams.columnFilter.transport_group_code;
    if (!raw) {
      return [];
    }

    return String(raw)
      .split(",")
      .map(s => s.trim())
      .filter(Boolean);
  }, [orderParams.columnFilter.transport_group_code]);

  const [selectedOrderGroupIds, setSelectedOrderGroupIds] = useState([]);

  const orderGroupSelectOptions = useMemo(
    () =>
      OPTION_ORDER_GROUP.map(item => ({
        value: String(item.value),
        label: item.label,
      })),
    []
  );

  const handleOrderGroupMultiChange = useCallback(
    nextIds => {
      const safeIds = Array.isArray(nextIds) ? nextIds : [];
      setSelectedOrderGroupIds(safeIds);

      const orderGroupFilterIds = joinMultiSelectIds({
        selectedIds: safeIds.length ? safeIds : undefined,
        options: orderGroupSelectOptions,
      });

      const hasCollectBloodOrBus = safeIds.some(
        id =>
          String(id) === String(ORDER_TYPE.COLLECTOR.value) ||
          String(id) === String(ORDER_TYPE.BUS_RECEIVE.value)
      );

      setOrderParams(prev => {
        const columnFilter = { ...prev.columnFilter };

        if (orderGroupFilterIds) {
          columnFilter.order_group = orderGroupFilterIds;
        } else {
          delete columnFilter.order_group;
        }

        if (hasCollectBloodOrBus) {
          delete columnFilter.transport_group_code;
          delete columnFilter["filter[transport_id]"];
        }

        return {
          ...prev,
          page: 1,
          run: true,
          columnFilter,
        };
      });
    },
    [orderGroupSelectOptions]
  );

  useEffect(() => {
    if (orderParams && orderParams.run) {
      listOrders();
    }
  }, [orderParams]);
  // EXPORT ORDERS

  const paramsExport = {
    params: {
      ...orderParams,
      columnFilter: {
        ...orderParams.columnFilter,
        "filter[id][in]": selectedIds,
      },
    },
  };

  const onExportSuccess = data => {
    if (data) {
      const outputFilename = `ExportFile-${Date.now()}.xlsx`;
      const url = URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  const { isLoading: isExportingFile, refetch: exportOrders } =
    useExportOrdersActive(paramsExport, onExportSuccess);

  useEffect(() => {
    const transportFromUrl = queryRouter.get("transport");
    const initTransportQuery = transportFromUrl
      ? {
        transport_group_code: undefined,
        "filter[transport_id]": transportFromUrl,
      }
      : {};

    const queryOrderGroup = queryRouter.get("order_group");
    const initOrderGroup = queryOrderGroup || String(ORDER_TYPE.RECEIVE.value);
    const initOrderGroupIds = initOrderGroup
      .split(",")
      .map(v => v.trim())
      .filter(Boolean);
    setSelectedOrderGroupIds(initOrderGroupIds);

    setOrderParams(prev => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      columnFilter: {
        ...prev.columnFilter,
        ...initTransportQuery,
        order_group: initOrderGroup,
        dashboard_key: queryRouter.get("key"),
        ...(!transportFromUrl
          ? {
            transport_group_code:
              prev.columnFilter.transport_group_code || "runner",
          }
          : {}),
      },
    }));

    onFetchStatusList();

  }, []);

  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  const filterOutItemObjectByKey = (obj, keyFilterOut) => {
    return Object.fromEntries(
      Object.entries(obj).filter(
        ([key, value]) => !key.startsWith(keyFilterOut)
      )
    );
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter: tableColumnFilter }
  ) => {
    setOrderParams(prev => {
      const baseColumnFilter = filterOutItemObjectByKey(
        prev.columnFilter,
        "filter[action_date]"
      );

      const nextColumnFilter = {
        ...baseColumnFilter,
        ...(tableColumnFilter || {}),
      };

      delete nextColumnFilter["filter[delay_time][like]"];

      if (!tableColumnFilter?.delay_time) {
        delete nextColumnFilter.delay_time;
      }

      return {
        ...prev,
        sort: sortField ? sortOrder + sortField : prev.sort,
        columnFilter: nextColumnFilter,
        page: page || 1,
        sizePerPage: sizePerPage || 10,
      };
    });
  };

  const handleForwardOrder = data => {
    const forwardOrderParams = { ...data };
    const idsForward = selectedRowAction
      ? [selectedRowAction?.id]
      : [...selectedIds];
    console.log("🚀 ~ handleForwardOrder ~ ids:", idsForward);
    forwardOrderParams.ids = idsForward;
    onForwardOrder(forwardOrderParams);
  };

  const handleChangeOrderStatus = data => {
    const orderParams = { ...data };
    orderParams.ids = selectedIds;
    changeOrderStatus(orderParams);
  };

  const isAnyNotAllowedGroupToTransfer = useMemo(() => {
    return checkIsAnyNotAllowedGroupToTransfer(orderList, selectedIds);
  }, [selectedIds, orderList]);

  const formatStatus = cell => {
    const status = statusListAllOptions.find(
      item => parseInt(item.value) === cell
    );
    return <div>{status?.label}</div>;
  };

  const clickViewOrderHandler = row => {
    switch (row.type) {
      case ORDER_TYPE.COLLECTOR.value:
        window.open(
          `/collection-order/${row.id}`,
          "_blank",
          "noopener,noreferrer"
        );
        break;

      default:
        window.open(
          `/manage-orders/${row.id}`,
          "_blank",
          "noopener,noreferrer"
        );
        break;
    }
  };

  const rightClickViewOrderHandler = (row, indexCol, e) => {
    if (e && (e.button === 1 || e.button === 2)) {
      switch (row.type) {
        case ORDER_TYPE.COLLECTOR.value:
          window.open(
            `/collection-order/${row.id}`,
            "_blank",
            "noopener,noreferrer"
          );
          break;

        default:
          window.open(
            `/manage-orders/${row.id}`,
            "_blank",
            "noopener,noreferrer"
          );
          break;
      }
    }
  };

  const createOrderGetGoodsHandler = (row, indexCol, e) => {
    console.log("🚀 ~ createOrderGetGoodsHandler ~ row:", row);
    setDataDefaultCreateOrderGetGoodsPopup({
      isCreateAfterOpen: true,
      bus_id: row?.orderDelivery?.bus_id,
      hub: {
        id: row?.from_hub,
        name: row?.from_hub_name,
      },
      order: row,
    });
    toggleOpenCreateOrderGetGoodsPopup();
  };

  const syncOrderGetGoodsHandler = (row, indexCol, e) => {
    setDataDefaultCreateOrderGetGoodsPopup({
      isCreateAfterOpen: true,
      bus_id: row?.receive_bus_id,
      hub: {
        id: row?.from_hub,
        name: row?.from_hub_name,
      },
      order: row,
    });
    toggleOpenCreateOrderGetGoodsPopup();
  };

  const toggleCancelOrderModal = () => {
    setCancelOrderModal(!cancelOrderModal);
  };

  const clickCancelOrderHandler = row => {
    setSelectedRow(row);
    setDataCancelOrder({ orderId: row.id });
    onFetchReasons();
    toggleCancelOrderModal();
  };

  const cancelSingleOrderHandler = value => {
    if (value.reasonId) {
      cancelOrder({
        orderId: dataCancelOrder.orderId,
        reason_note: value.note,
        reason_id: value.reasonId,
        order_code: selectedRow.order_code,
      });
      toggleCancelOrderModal();
    }
  };

  const handleSingleCoordinate = row => {
    console.log("🚀 ~ handleSingleCoordinate ~ row:", row);
    setSelectedRowAction(row);
    let { messError, hub_id, isCollector } =
      checkErrorForHandleOrdersCoordinate({
        selectedRows: [row],
      });
    if (messError) {
      addToast(messError, {
        appearance: "warning",
        autoDismiss: true,
      });
    } else {
      setHubId(hub_id);
      setTimeSlotsParams(prev => {
        return {
          ...prev,
          params: {
            ...prev.params,
            "filter[hub_id]": hub_id,
          },
          run: true,
        };
      });
      if (row?.type === ORDER_TYPE.RECEIVE.value) {
        setDefaultDataOrderCoordination({
          timeslot_id: row?.timeslot_id,
          runner_id: row?.orderDelivery?.runner_id,
          full_address: row?.sender_address,
          ward_code: row?.sender_ward_code,
          district_code: row?.sender_district_code,
          province_code: row?.sender_province_code,
          contact_name: row?.sender_contact_name,
          contact_phone: row?.sender_contact_phone,
          note: `${row?.mainNote || row?.note || ""}`,
          is_new_address: row?.is_new_address,
        });
      } else {
        setDefaultDataOrderCoordination({
          timeslot_id: row?.timeslot_id,
          runner_id: row?.orderDelivery?.runner_id,
          full_address: row?.reciever_address,
          ward_code: row?.reciever_ward_code,
          district_code: row?.reciever_district_code,
          province_code: row?.reciever_province_code,
          contact_name: row?.reciever_contact_name,
          contact_phone: row?.reciever_contact_phone,
          note: `${row?.mainNote || row?.note || ""}`,
          is_new_address: row?.is_new_address,
        });
      }
      setOpenForwardOrderPopup(isCollector ? "collector" : true);
    }
  };

  const handleDateRangeFilter = ({ startDate, endDate }) => {
    const columnFilter = { ...orderParams.columnFilter };

    setStartDate(startDate);
    setEndDate(endDate);

    delete columnFilter["filter[action_date][gte]"];
    delete columnFilter["filter[action_date][lte]"];
    delete columnFilter["filter[maker_date][gte]"];
    delete columnFilter["filter[maker_date][lte]"];
    delete columnFilter["filter[action_date][eq]"];
    delete columnFilter["filter[maker_date][eq]"];
    let keyFilter = "maker_date";
    if (startDate && endDate) {
      columnFilter[`filter[${keyFilter}][gte]`] = startDate
        ? startDate.format("YYYY-MM-DD")
        : null;
      columnFilter[`filter[${keyFilter}][lte]`] = endDate
        ? endDate.format("YYYY-MM-DD")
        : null;
    } else if (startDate) {
      columnFilter[`filter[${keyFilter}][eq]`] = startDate
        ? startDate.format("YYYY-MM-DD")
        : null;
    } else if (endDate) {
      columnFilter[`filter[${keyFilter}][eq]`] = endDate
        ? endDate.format("YYYY-MM-DD")
        : null;
    }
    setOrderParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const statusSelectOptions = useMemo(
    () =>
      (statusListAllOptions || [])
        .filter(item => item.value !== "All")
        .map(item => ({
          value: String(item.value),
          label: item.label,
        })),
    [statusListAllOptions]
  );

  const selectedStatusIds = useMemo(() => {
    const parsedIds = parseMultiSelectIds(
      orderParams.columnFilter?.[STATUS_FILTER_KEY]
    );

    if (!parsedIds.length || !statusSelectOptions.length) {
      return [];
    }

    const allStatusIds = joinMultiSelectIds({
      selectedIds: undefined,
      options: statusSelectOptions,
    });

    if (parsedIds.join(",") === allStatusIds) {
      return [];
    }

    return parsedIds;
  }, [orderParams.columnFilter, statusSelectOptions]);

  const handleStatusMultiSelectChange = useCallback(
    statuses => {
      const statusFilterIds = joinMultiSelectIds({
        selectedIds: statuses,
        options: statusSelectOptions,
      });

      setOrderParams(prev => {
        const columnFilter = { ...prev.columnFilter };

        if (statusFilterIds) {
          columnFilter[STATUS_FILTER_KEY] = statusFilterIds;
        }

        return {
          ...prev,
          page: 1,
          run: true,
          columnFilter,
        };
      });
    },
    [statusSelectOptions]
  );

  const handleRowsSelect = (ids, row) => {
    setSelectedIds(ids);
    setSelectedOrderCode(row.map(item => item.order_code));
    setSelectedRows(row);
  };

  const handleCoordinate = () => {
    if (selectedIds && selectedIds.length > 0) {
      let { messError, hub_id, isCollector } =
        checkErrorForHandleOrdersCoordinate({
          selectedRows: selectedRows,
        });

      if (messError) {
        addToast(messError, {
          appearance: "warning",
          autoDismiss: true,
        });
      } else {
        setHubId(hub_id);
        setTimeSlotsParams(prev => {
          return {
            ...prev,
            params: {
              ...prev.params,
              "filter[hub_id]": hub_id,
            },
            run: true,
          };
        });

        const firstOrder = selectedRows[0];

        if (selectedRows.length > 1) {
          const allLevel2 = selectedRows.every(
            row => row.is_new_address === "N"
          );
          const allLevel3 = selectedRows.every(
            row => row.is_new_address !== "N"
          );

          if (!allLevel2 && !allLevel3) {
            addToast("Vui lòng chọn đơn cùng cấp địa chỉ", {
              appearance: "warning",
              autoDismiss: true,
            });
            return;
          }

          setIsAddressLevel2(allLevel2);

          setDefaultDataOrderCoordination({
            timeslot_id: null,
            runner_id: null,
            full_address: "",
            ward_code: null,
            district_code: null,
            province_code: null,
            contact_name: "",
            contact_phone: "",
            note: "",
            is_new_address: allLevel2 ? "N" : "O",
          });
        } else if (firstOrder) {
          setIsAddressLevel2(firstOrder?.is_new_address === "N");

          const isReceive = firstOrder?.type === ORDER_TYPE.RECEIVE.value;
          const prefix = isReceive ? "sender" : "reciever";

          setDefaultDataOrderCoordination({
            timeslot_id: firstOrder?.timeslot_id,
            runner_id: firstOrder?.orderDelivery?.runner_id,
            full_address: firstOrder?.[`${prefix}_address`],
            ward_code: firstOrder?.[`${prefix}_ward_code`],
            district_code: firstOrder?.[`${prefix}_district_code`],
            province_code: firstOrder?.[`${prefix}_province_code`],
            contact_name: firstOrder?.[`${prefix}_contact_name`],
            contact_phone: firstOrder?.[`${prefix}_contact_phone`],
            note: `${firstOrder?.mainNote || firstOrder?.note || ""}`,
            is_new_address: firstOrder?.is_new_address,
          });
        }

        setOpenForwardOrderPopup(isCollector ? "collector" : true);
      }
    } else {
      addToast(t("message.not_selected_information"), {
        appearance: "warning",
        autoDismiss: true,
      });
    }
  };

  const handleChangeStatus = () => {
    if (selectedIds && selectedIds.length > 0) {
      setOpenChangeOrderStatusPopup(!openChangeOrderStatusPopup);
    } else {
      addToast(t("message.not_selected_information"), {
        appearance: "warning",
        autoDismiss: true,
      });
    }
  };

  const onFetchRetryOrderSuccess = response => {
    listOrders();
  };
  const onFetchRetryOrderFail = response => { };

  const { mutate: mutateRetryOrder } = useRetryOrder(
    onFetchRetryOrderSuccess,
    onFetchRetryOrderFail
  );

  const handleSendBackDVVC = () => {
    if (selectedOrderCode && selectedOrderCode.length > 0) {
      mutateRetryOrder(selectedOrderCode);
    } else {
      addToast(t("message.not_selected_information"), {
        appearance: "warning",
        autoDismiss: true,
      });
    }
  };

  const handleOrderBusLateFilter = () => {
    setIsFilterOrderBusLate(!isFilterOrderBusLate);
  };

  useEffect(() => {
    const columnFilterBusLate = { ...orderParams.columnFilter };
    if (!orderParams?.run) {
      return;
    }
    if (isFilterOrderBusLate) {
      // START Tắt đơn gom
      delete columnFilterBusLate["filter[transport_id]"];
      delete columnFilterBusLate["transport_group_code"];
      delete columnFilterBusLate["filter[is_sub_order]"];
      delete columnFilterBusLate["filter[transport_id]"];
      delete columnFilterBusLate["filter[parent_id]"];
      // END Tắt đơn gom

      // START Đơn nhận hàng
      columnFilterBusLate.order_group = String(ORDER_TYPE.RECEIVE.value);
      setSelectedOrderGroupIds([String(ORDER_TYPE.RECEIVE.value)]);
      // END Đơn nhận hàng

      // START Trạng thái tạo đơn
      columnFilterBusLate[STATUS_FILTER_KEY] = String(orderStatusMode.MAKE);
      // END Trạng thái tạo đơn

      // START ĐVVC Chành xe
      columnFilterBusLate["filter[transport_id]"] = undefined;
      columnFilterBusLate["filter[shipping_type][in]"] = undefined;
      columnFilterBusLate["transport_group_code"] = "chanhxe";
      // END ĐVVC Chành xe

      //
      columnFilterBusLate["filter[receive_bus_is_late]"] = 1;
      //
    } else {
      //
      columnFilterBusLate["filter[receive_bus_is_late]"] = undefined;
      //
      // START Trạng thái Tất cả
      delete columnFilterBusLate[STATUS_FILTER_KEY];
      // END Trạng thái Tất cả
    }

    setOrderParams(prev => ({
      ...prev,
      columnFilter: columnFilterBusLate,
    }));
  }, [isFilterOrderBusLate]);

  const onSearchAllHandle = value => {
    setOrderParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const handleExportFile = () => {
    if (selectedIds.length === 0) {
      addToast(t("message.not_selected_information"), {
        appearance: "warning",
        autoDismiss: true,
      });
      return;
    }
    exportOrders();
  };

  const onSetDaySize = () => {
    if (window.matchMedia("(max-width: 560px)").matches) {
      return 22;
    }
    if (window.matchMedia("(max-width: 800px)").matches) {
      return 24;
    }
    return undefined;
  };

  /* ================================ END FUNCTION HANDLER ================================= */

  const selectRow = {
    mode: "checkbox",
    // clickToSelect: true,
    bgColor: "#00BFFF",
    onSelect: handleRowsSelect,
  };

  const initColumns = [
    {
      dataField: "address_type",
      text: "Loại",
      sort: false,
      formatter: (_cell, row) => {
        const isRowLevel2 = row?.is_new_address === "N";
        const isEditing = editingCostOrderId === row.id;
        const displayCost = row.cost
          ? formatOrderCostMoney(toOrderCostThousandUnit(row.cost))
          : "";

        return (
          <div
            style={{ minWidth: 90, cursor: "pointer" }}
            onClick={() => {
              setEditingCostOrderId(row.id);
              setEditingCostValue(
                row.cost ? String(toOrderCostThousandUnit(row.cost)) : ""
              );
            }}
            title="Click để nhập chi phí"
          >
            <span
              className={`badge ${isRowLevel2 ? "bg-info" : "bg-secondary"}`}
              style={{
                fontSize: "11px",
                padding: "4px 8px",
                textAlign: "center",
                display: "inline-block",
              }}
            >
              {isRowLevel2 ? "2 cấp" : "3 cấp"}
            </span>

            {isEditing && (
              <input
                autoFocus
                type="text"
                inputMode="numeric"
                className="form-control form-control-sm mt-1"
                value={formatOrderCostMoney(editingCostValue)}
                onChange={e => setEditingCostValue(parseOrderCostMoney(e.target.value))}
                onBlur={() => setEditingCostOrderId(null)}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    const currentDigits = parseOrderCostMoney(editingCostValue);
                    const nextCost = fromOrderCostThousandUnit(currentDigits);
                    const prevCost = Number(row.cost || 0);

                    if (nextCost === prevCost) {
                      setEditingCostOrderId(null);
                      return;
                    }

                    handleUpdateOrderCost(row.id, currentDigits);
                  }

                  if (e.key === "Escape") {
                    setEditingCostOrderId(null);
                  }
                }}
                placeholder={displayCost || "Nhập số tiền"}
              />
            )}
          </div>
        );
      },
    },
    {
      dataField: "maker_date",
      text: "Thời gian tạo",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "120px" };
      },
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          })
            .format(Number(cell) * 1000)
            .replace(",", "");
        } else {
          return "";
        }
      },
    },
    // {
    //   dataField: "delay_time",
    //   text: t("table.time"),
    //   sort: true,
    //   formatter: cell => {
    //     return cell;
    //   },
    // },
    {
      dataField: "delay_time",
      text: "DU",
      // sort: true,
      filter: textFilter({
        delay: DELAY_FILTER_TIME,
        className: "form-control-sm",
        placeholder: "Nhập DU",
        style: { width: "65px", minWidth: "65px", maxWidth: "65px", height: 34 },
        onInput: e => e.target.value = e.target.value.replace(/\D/g, "")
      }),
      formatter: cell => {
        if (!cell) return "";
        return String(cell).replace(/\s*ngày\s*/gi, " D");
      },
    },
    {
      dataField: "type",
      text: t("table.type"),
      sort: true,
      formatter: cell => {
        return findOrderType(cell, listOrderType)?.label;
      },
    },
    {
      dataField: "order_code",
      text: t("table.id"),
      sort: true,
      formatter: (cell, row) => <OrderCodeCopy code={cell} />,
    },
    {
      dataField: "ref_code",
      text: t("table.package_code"),
      sort: true,
      formatter: (cell, row) => {
        // const isAllowUpdateRefCode =
        //   row?.shipping_type === 3 && (row?.status === 1 || row?.status === 6); // Là đơn chành xe: shipping_type = 3 , trạng thái đơn là: tạo đơn, đang chờ
        const isAllowUpdateRefCode = isLogAdmin;
        const isAllowUpdateExistRefCode =
          isLogAdmin && checkItemAcceptForUpdateExitsRefCode(row);
        return (
          <RefCode
            t={t}
            ref_code={cell}
            data={row}
            isAllowUpdateRefCode={isAllowUpdateRefCode}
            onUpdateRefCode={() =>
              updateRefCodeModalRef?.current?.openModal({
                orderId: row?.id,
                orderRefCode: row.ref_code,
              })
            }
            isAllowUpdateExistRefCode={isAllowUpdateExistRefCode}
            onUpdateExistRefCode={() =>
              updateRefCodeModalRef?.current?.openModal({
                orderId: row?.id,
                orderRefCode: row.ref_code,
                isUpdateExist: true,
              })
            }
          />
        );
      },
    },
    // {
    //   dataField: "from_hub_name",
    //   text: "Nơi gửi",
    //   formatter: cell => {
    //     return <div className="text-info fw-bold">{cell}</div>;
    //   },
    // },
    // {
    //   dataField: "to_hub_name",
    //   text: "Nơi nhận",
    //   formatter: cell => {
    //     return <div className="text-success fw-bold">{cell}</div>;
    //   },
    // },
    {
      dataField: "status",
      text: t("table.status"),
      sort: true,
      formatter: cell => {
        return formatStatus(cell);
      },
    },
    // {
    //   dataField: "sender_name",
    //   text: t("table.customer"),
    //   sort: true,
    //   formatter: (cell, row) => {
    //     return row.type === ORDER_TYPE.RETURN.value
    //       ? row.reciever_name
    //       : row.sender_name;
    //   },
    // },
    {
      dataField: "sender_name",
      text: t("table.customer"),
      sort: true,
      headerStyle: {
        width: "200px",
        minWidth: "200px",
        maxWidth: "200px",
      },
      style: {
        width: "200px",
        minWidth: "200px",
        maxWidth: "200px",
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflow: "hidden",
      },
      formatter: (cell, row) => {
        const customerName =
          row.type === ORDER_TYPE.RETURN.value
            ? row.reciever_name
            : row.sender_name;
        return (
          <div
            style={{
              wordBreak: "break-word",
              whiteSpace: "normal",
            }}
          >
            {customerName}
          </div>
        );
      },
    },
    {
      dataField: "sender_contact_phone",
      text: t("table.SDT"),
      sort: true,
      formatter: (cell, row) => {
        return row.type === ORDER_TYPE.RETURN.value
          ? row.reciever_contact_phone
          : row.sender_contact_phone;
      },
    },
    // {
    //   dataField: "address",
    //   text: t("table.address"),
    //   sort: true,
    //   formatter: (cell, row) => (
    //     <div
    //       dangerouslySetInnerHTML={{
    //         __html: splitText(
    //           row.type === ORDER_TYPE.RETURN.value
    //             ? row.reciever_full_address
    //             : row.sender_full_address,
    //           [
    //             {
    //               limit_width: 3000,
    //               limit_text_length: 50,
    //             },
    //             {
    //               limit_width: 600,
    //               limit_text_length: 30,
    //             },
    //           ]
    //         ),
    //       }}
    //     />
    //   ),
    // },
    {
      dataField: "address",
      text: t("table.address"),
      sort: true,
      headerStyle: {
        width: "200px",
        minWidth: "200px",
        maxWidth: "200px",
      },
      style: {
        width: "200px",
        minWidth: "200px",
        maxWidth: "200px",
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflow: "hidden",
      },
      formatter: (cell, row) => {
        const address =
          row.type === ORDER_TYPE.RETURN.value
            ? row.reciever_full_address
            : row.sender_full_address;

        return (
          <div
            style={{
              wordBreak: "break-word",
              whiteSpace: "normal",
            }}
          >
            {address}
          </div>
        );
      },
    },
    {
      dataField: "transport_name",
      text: t("table.transport_id"),
      sort: true,
    },
    {
      dataField: "sale_name",
      text: t("table.sale"),
      sort: true,
    },
    {
      dataField: "action_date",
      text: "Ngày hẹn",
      formatter: (cell, row) => {
        if (!cell) return "";
        return moment(cell).format("DD/MM/YYYY");
      },
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => {
        return (
          <CustomDateFilter
            onFilter={onFilter}
            column={column}
            paramFilter={orderParams.columnFilter}
            containerWidth="80px"
          />
        );
      },
    },
    {
      dataField: "timeslot_id",
      text: "Thời gian hẹn",
      formatter: (cell, row) => {
        return row?.time_slot_name;
      },
      filter: customFilter({
        type: CUSTOM_SELECT_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => {
        return (
          <div style={{ maxWidth: "80px", fontWeight: "normal" }}>
            <Select
              isClearable
              placeholder="Thời gian hẹn"
              options={timeslotFilterOptions}
              classNamePrefix="select2-selection"
              value={timeSlotsSelect}
              onChange={data => {
                onFilterOrderTimeSlot(data);
                setTimeSlotsSelect(data);
              }}
            />
          </div>
        );
      },
    },
  ];

  const timeslotFilterOptions = useMemo(() => {
    if (
      timeSlotsFilter &&
      timeSlotsFilter.items &&
      timeSlotsFilter.items.length > 0
    ) {
      return timeSlotsFilter.items?.map(item => ({
        label: item.name,
        value: item.id,
      }));
    }

    return [];
  }, [timeSlotsFilter]);

  const onFilterOrderTimeSlot = timesLotId => {
    const columnFilter = { ...orderParams.columnFilter };

    if (timesLotId) {
      columnFilter["filter[timeslot_id]"] = timesLotId.value;
    } else {
      delete columnFilter["filter[timeslot_id]"];
    }

    setOrderParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const listRowAction = [
    {
      icon: <i className="fas fa-sync fa-lg text-success ms-2" />,
      text: "Đồng bộ đơn con",
      onClick: syncOrderGetGoodsHandler,
      conditionVisible: {
        status: [
          orderStatusMode.MAKE,
          orderStatusMode.WAITING,
          orderStatusMode.COORDINATED,
        ],
        is_receive_bus: [1],
      },
    },
    {
      icon: <i className="fas fa-truck fa-lg text-success ms-2" />,
      text: "Tạo đơn lấy hàng nhà xe",
      onClick: createOrderGetGoodsHandler,
      conditionVisible: {
        status: [1],
        shipping_type: [SHIPPING_TYPE.NHAXE],
        parent_id: [null],
      },
    },
    {
      icon: <i className="fas fa-calendar fa-lg text-success ms-2" />,
      text: "Xem đơn lấy hàng nhà xe",
      onClick: row => {
        window.open(
          `/manage-orders/${row.parent_id}`,
          "_blank",
          "noopener,noreferrer"
        );
      },
      conditionVisible: {
        shipping_type: [SHIPPING_TYPE.NHAXE],
        parent_id: [],
      },
    },
    {
      actionAccess: actionAccess.GLOG_FUNCTION_ORDER_VIEW,
      icon: <i className="fas fa-eye fa-lg text-primary ms-2" />,
      text: t("actions.view"),
      onClick: clickViewOrderHandler,
      onRightClick: rightClickViewOrderHandler,
    },
    {
      icon: <i className="fas fa-copy fa-lg text-info" />,
      text: "Copy thông tin",
      onClick: row =>
        copyInformationOrderToClipboard({
          order_code: row.order_code,
          ref_code: row.ref_code,
          status: statusListAllOptions.find(
            item => parseInt(item.value) === row.status
          )?.label,
          customer:
            row.type === ORDER_TYPE.RETURN.value
              ? row.reciever_name
              : row.sender_name,
          contact_name:
            row.type === ORDER_TYPE.RETURN.value
              ? row.reciever_contact_name
              : row.sender_contact_name,
          phone:
            row.type === ORDER_TYPE.RETURN.value
              ? row.reciever_contact_phone
              : row.sender_contact_phone,
          address:
            row.type === ORDER_TYPE.RETURN.value
              ? row.reciever_full_address
              : row.sender_full_address,
          mainNote: row.mainNote,
        }),
    },
    {
      isShow: !isHubAdmin,
      actionAccess: actionAccess.GLOG_FUNCTION_ORDER_CANCEL,
      icon: <i className="fas fa-times fa-lg ms-2 text-danger" />,
      text: t("actions.cancel"),
      onClick: clickCancelOrderHandler,
      conditionVisible: {
        status: [6],
      },
    },
    {
      isShow: !isHubAdmin,
      actionAccess: actionAccess.GLOG_FUNCTION_ORDER_VIEW,
      icon: <i className="fas fa-location-arrow fa-lg text-success ms-2" />,
      text: t("actions.coordinate"),
      onClick: row => handleSingleCoordinate(row),
      conditionVisible: {
        shipping_type: [SHIPPING_TYPE.RUNNER],
        status: [
          STATUS.COORDINATED,
          STATUS.HUB_ARRIVED,
          STATUS.NEW,
          STATUS.PENDING,
        ],
      },
    },
  ];
  const rowActionList = CheckActionAccessList(listRowAction, "actionAccess");

  useEffect(() => {
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const listRole = info["auth"].split(",");
    setIsHubAdmin(
      listRole.find(item => item.includes(ROLE_APP.ROLE_HUB_ADMIN))
        ? true
        : false || false
    );
    setIsLogAdmin(
      listRole.find(item => item.includes(ROLE_APP.ROLE_LOG_ADMIN))
        ? true
        : false || false
    );
  }, []);

  useEffect(() => {
    if (orderParams && orderParams.run) {
      listOrders();
    }
  }, [orderParams]);

  useEffect(() => {
    if (orderList) {
      setColumnsTable(initColumns);
      setSelectedIds([]);
      setSelectedRows([]);
      setHubId(null);
    }
  }, [orderList, editingCostOrderId, editingCostValue]);

  useEffect(() => {
    setColumnsTable(initColumns);
  }, [orderStatusList, timeslotFilterOptions, editingCostOrderId, editingCostValue]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Modal
          isOpen={
            openForwardOrderPopup && openForwardOrderPopup !== "collector"
          }
          centered
          toggle={() => {
            setOpenForwardOrderPopup(false);
            setDefaultDataOrderCoordination(null);
            setSelectedRowAction(null);
          }}
          size="xl"
          scrollable
        >
          {openForwardOrderPopup && openForwardOrderPopup !== "collector" && (
            <OrderCoordinationForm
              defaultData={defaultDataOrderCoordination}
              hubId={hubId}
              timeSlots={timeSlots?.items}
              isAddressLevel2={is_level_2}
              handleCancel={() => {
                setOpenForwardOrderPopup(false);
                setDefaultDataOrderCoordination(null);
                setSelectedRowAction(null);
              }}
              onTimeSlotChange={timeslot_id => {
                const params = { ...runnerByRuleParams };
                params.time_slot = timeslot_id;
                setRunnerByRuleParams(params);
              }}
              onActionDateChange={action_date => {
                const params = { ...runnerByRuleParams };
                params.action_date = action_date;
                setRunnerByRuleParams(params);
              }}
              onForwardOrder={handleForwardOrder}
            />
          )}
        </Modal>
        <CoordinateCollectorOrder
          orderIds={selectedRowAction ? [selectedRowAction?.id] : selectedIds}
          hubId={hubId}
          isAddressLevel2={isAddressLevel2}
          isOpenCoordinateModal={
            openForwardOrderPopup && openForwardOrderPopup === "collector"
          }
          // orderDetail={selectedRowAction || (selectedRows && selectedRows[0])}

          orderDetail={
            selectedRowAction ||
            (selectedRows.length > 1 ? null : selectedRows[0])
          }
          clearSelect={() => {
            setSelectedRowAction(null);
            setIsAddressLevel2(undefined);
          }}
          setIsOpenCoordinateModal={setOpenForwardOrderPopup}
          refetchSuccess={listOrders}
        />

        <Modal
          isOpen={openChangeOrderStatusPopup}
          centered
          toggle={() =>
            setOpenChangeOrderStatusPopup(!openChangeOrderStatusPopup)
          }
        >
          <ChangeOrderStatusForm
            orderStatusList={orderStatusList}
            handleCancel={() => {
              setOpenChangeOrderStatusPopup(false);
            }}
            onSubmit={handleChangeOrderStatus}
            isAnyNotAllowedGroupToTransfer={isAnyNotAllowedGroupToTransfer}
            placeHolderNotAllowedGroupToTransfer="Không thể chọn vì nhóm đối tượng có tồn tại đơn nội thành"
          />
        </Modal>
        <CreateOrderGetGoodsModal
          dataDefaultCreateOrderGetGoodsPopup={
            dataDefaultCreateOrderGetGoodsPopup
          }
          isLogAdmin={isLogAdmin}
          createOrderSuccessHandle={() => {
            listOrders();
            setDataDefaultCreateOrderGetGoodsPopup({
              isCreateAfterOpen: false,
              bus_id: null,
              hub: null,
              order: null,
            });
          }}
          isOpen={openCreateOrderGetGoodsPopup}
          toggle={toggleOpenCreateOrderGetGoodsPopup}
        />
        <MetaTags>
          <title>Manage Orders</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={
              t("title.manage_active") + ` (${orderList?.totalCount || 0})`
            }
          />
          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              <UpdateRefCodeModal
                ref={updateRefCodeModalRef}
                handleOnSuccessInsertOrderRefCode={() => {
                  listOrders();
                }}
              />
              <ConfirmModal
                isOpen={cancelOrderModal}
                titleHeader={
                  t("actions.deleteModal.title") +
                  `${selectedRow.order_code}` +
                  "?"
                }
                titleBody={t("actions.deleteModal.content")}
                onConfirm={cancelSingleOrderHandler}
                textBtnConfirm={t("actions.deleteModal.confirmBtn")}
                textBtnCancel={t("actions.deleteModal.cancelBtn")}
                toggle={toggleCancelOrderModal}
                isReasonDeleteCheckbox={true}
                reasonList={reasonListData?.items}
                isHaveNote={true}
              />
            </Col>

            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    isShowRowIndex={false}
                    keyField="id"
                    data={orderList?.items || []}
                    columns={columnsTable}
                    selectRow={selectRow}
                    page={orderList?.params?.page}
                    sizePerPage={orderList?.params?.sizePerPage}
                    totalSize={orderList?.totalCount}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    listRowAction={rowActionList}
                    onRowsSelect={handleRowsSelect}
                    loading={isLoadingListOrder}
                    searchSticky={true}
                    sizePerPageListAppend={[
                      {
                        text: "100",
                        value: 100,
                      },
                    ]}
                  >
                    <div className="d-flex flex-column flex-md-row flex-grow-0 flex-lg-grow-1 flex-md-wrap justify-content-md-between">
                      <div
                        className="d-flex flex-column flex-sm-wrap flex-sm-row mb-md-0"
                        style={{ gap: "0.5rem" }}
                      >
                        {/* <Label
                          className="d-flex align-items-center gap-1 mb-0"
                          style={{ cursor: "pointer" }}
                          htmlFor="is_level_2"
                          onClick={() => handleChangeIsLevel2(!is_level_2)}
                        >
                          <Switch
                            className=""
                            checked={is_level_2}
                            onChange={handleChangeIsLevel2}
                          />
                          Địa chỉ 2 cấp
                        </Label> */}
                        <div>
                          <DateRangePicker
                            numberOfMonths={1}
                            startDate={startDate}
                            startDateId="s_id"
                            endDate={endDate}
                            endDateId="e_id"
                            startDatePlaceholderText={t("title.startDate")}
                            endDatePlaceholderText={t("title.endDate")}
                            isOutsideRange={() => false}
                            onDatesChange={handleDateRangeFilter}
                            focusedInput={focusedInput}
                            onFocusChange={e => setFocusedInput(e)}
                            displayFormat="DD/MM/YYYY"
                            daySize={onSetDaySize()}
                            orientation={
                              window.matchMedia("(max-width: 700px)").matches
                                ? "vertical"
                                : "horizontal"
                            }
                          />
                        </div>
                        <div className="d-flex">
                          {/* <div
                            className={
                              window.matchMedia("(max-width: 575px)").matches
                                ? "w-50"
                                : ""
                            }
                            style={{ paddingRight: 8 }}
                          >
                            <Dropdown
                              isOpen={isOpenAddrFilter}
                              toggle={() =>
                                setIsOpenAddrFilter(!isOpenAddrFilter)
                              }
                            >
                              <DropdownToggle
                                className="btn primary-btn w-100 text-overflow"
                                caret
                              >
                                Địa chỉ
                                <span>:&nbsp;{addressLevelFilter.label}</span>
                                <i className="mdi mdi-chevron-down" />
                              </DropdownToggle>
                              <DropdownMenu
                                className="w-100"
                                style={{ minWidth: 100 }}
                              >
                                {addressLevelFilterOptions.map(opt => (
                                  <DropdownItem
                                    key={opt.value}
                                    onClick={() =>
                                      handleAddressLevelFilterChange(opt)
                                    }
                                  >
                                    {opt.label}
                                  </DropdownItem>
                                ))}
                              </DropdownMenu>
                            </Dropdown>
                          </div> */}
                          <div
                            className={
                              window.matchMedia("(max-width: 575px)").matches
                                ? "w-50"
                                : ""
                            }
                            style={{ paddingRight: 8 }}
                          >
                            <HubMultiSelectFilter
                              label="Hub"
                              hubSelectOptions={hubSelectOptions}
                              selectedHubIds={selectedHubIds}
                              onChange={handleHubMultiSelectChange}
                            />
                          </div>
                          <div
                            className={
                              window.matchMedia("(max-width: 575px)").matches
                                ? "w-50"
                                : ""
                            }
                            style={{ paddingRight: 8 }}
                          >
                            <HubMultiSelectFilter
                              label={t("filters.status.label")}
                              hubSelectOptions={statusSelectOptions}
                              selectedHubIds={selectedStatusIds}
                              onChange={handleStatusMultiSelectChange}
                            />
                          </div>
                          <div
                            className={
                              window.matchMedia("(max-width: 575px)").matches
                                ? "w-50"
                                : ""
                            }
                            style={{ flex: "0 0 auto" }}
                          >
                            <GroupTransportMultiFilter
                              label={"ĐVVC"}
                              onChange={onChangeGroupTransportMulti}
                              selectedCodes={selectedTransportGroupCodes}
                              runnerVisible
                            />
                          </div>
                        </div>
                        <div className="d-flex">
                          <div
                            className={
                              window.matchMedia("(max-width: 575px)").matches
                                ? "w-50 "
                                : ""
                            }
                            style={{ paddingLeft: 0 }}
                          >
                            <Button
                              className="mb-2 w-100"
                              color={
                                isFilterOrderBusLate ? "primary" : "secondary"
                              }
                              type="button"
                              onClick={() => {
                                handleOrderBusLateFilter();
                              }}
                            >
                              {"Chành xe trễ"}
                            </Button>
                          </div>
                        </div>
                      </div>

                      <div
                        className="d-flex flex-wrap mb-md-0"
                        style={{ gap: "0.5rem" }}
                      >
                        <div className="mb-2" style={{ flex: "0 0 auto" }}>
                          <HubMultiSelectFilter
                            label="Loại đơn"
                            hubSelectOptions={orderGroupSelectOptions}
                            selectedHubIds={selectedOrderGroupIds}
                            onChange={handleOrderGroupMultiChange}
                          />
                        </div>
                        {isAllowCreate && !isHubAdmin && (
                          <Button
                            className="mb-2"
                            type="button"
                            color="primary"
                            onClick={() => {
                              navigate(
                                `/manage-orders-active/create${selectedOrderCode?.length > 0
                                  ? `/?sub_order_codes=${selectedOrderCode.join(
                                    ","
                                  )}`
                                  : ""
                                }`
                              );
                            }}
                          >
                            {"Lấy mẫu"}
                          </Button>
                        )}
                        {!isHubAdmin && (
                          <Button
                            className="mb-2"
                            type="button"
                            color="danger"
                            onClick={() => {
                              navigate("/collection-order/create");
                            }}
                          >
                            {"Lấy máu"}
                          </Button>
                        )}
                        <Button
                          className="mb-2"
                          type="button"
                          color="success"
                          onClick={() => {
                            setDataDefaultCreateOrderGetGoodsPopup({
                              isCreateAfterOpen: false,
                              bus_id: null,
                              hub: null,
                              order: null,
                            });
                            toggleOpenCreateOrderGetGoodsPopup();
                          }}
                        >
                          {"Lấy nhà xe"}
                        </Button>
                        {isAllowExport && (
                          <Dropdown
                            isOpen={actionType}
                            toggle={() => setActionType(!actionType)}
                          >
                            <DropdownToggle className="btn primary-btn" caret>
                              Tác vụ <i className="mdi mdi-chevron-down" />{" "}
                              {!!isExportingFile && (
                                <Spinner
                                  // style={{ marginLeft: "5px" }}
                                  color="white"
                                  size="sm"
                                />
                              )}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={handleExportFile}>
                                {t("actions.exportFile")}{" "}
                              </DropdownItem>
                              {!isHubAdmin && (
                                <>
                                  <DropdownItem onClick={handleCoordinate}>
                                    {t("actions.coordinate")}{" "}
                                  </DropdownItem>
                                  <DropdownItem onClick={handleChangeStatus}>
                                    {t("actions.change_status")}{" "}
                                  </DropdownItem>
                                  <DropdownItem onClick={handleSendBackDVVC}>
                                    {t("actions.send_back_dvvc")}{" "}
                                  </DropdownItem>
                                </>
                              )}
                            </DropdownMenu>
                          </Dropdown>
                        )}
                      </div>
                    </div>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ManageOrdersPageActive;
